import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { MessageFeedbackComponent } from '@app/shared/components/message-feedback/message-feedback.component';
import { Observable } from 'rxjs';
import { Orgao } from '@app/shared/models/orgao';
import { Select } from 'primeng/select';

@Component({
	selector: 'sgp-select-orgao',
	standalone: true,
	imports: [ReactiveFormsModule, AsyncPipe, TitleCasePipe, MessageFeedbackComponent, Select],
	templateUrl: './select-orgao.component.html'
})
export class SelectOrgaoComponent {
	@Input() control!: FormControl;
	@Input() options$?: Observable<Orgao[]>;
	@Input() label = 'Órgão (obrigatório):';
	@Input() showError = false;
	@Input() placeholder = 'Selecione o órgão';
	@Output() changed = new EventEmitter<Orgao>();
}
